import React from "react";
import PropTypes from "prop-types";
import { MapPinPen, Plus } from "lucide-react";

import { UIEmptyState } from "../../../ui";

import "./EmptyZonesState.scss";

const EmptyZonesState = ({ title, description, actionLabel, onAddZone }) => (
  <UIEmptyState
    title={title}
    description={description}
    icon={<MapPinPen size={40} strokeWidth={1.5} />}
    actionLabel={actionLabel}
    actionIcon={<Plus size={18} />}
    onAction={onAddZone}
    classNames={{
      description: "empty-zones-state__description",
      iconCircle: "empty-zones-state__icon-circle",
    }}
  />
);

EmptyZonesState.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  actionLabel: PropTypes.string.isRequired,
  onAddZone: PropTypes.func,
};

EmptyZonesState.defaultProps = {
  onAddZone: undefined,
};

export default EmptyZonesState;
